/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/quantity/custom-elements';

import { defineCustomElement as defineOsdsQuantity } from '@ovhcloud/ods-stencil/components/quantity/custom-elements/osds-quantity.js';

export const OsdsQuantity = /*@__PURE__*/createReactComponent<JSX.OsdsQuantity, HTMLOsdsQuantityElement>('osds-quantity', undefined, undefined, defineOsdsQuantity);
